<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div id="status" *ngIf="!loaded && !error">
          <div class="spinner">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <ngb-alert [dismissible]="false" type="danger" *ngIf="error">
          {{ error }}
        </ngb-alert>

        <form #f="ngForm" (ngSubmit)="onSubmit(f)" novalidate *ngIf="loaded">
          <div class="row align-items-end">
            
            <div class="col-md-5 mb-3">
              <label for="inputNumeroExpediente" class="form-label" i18n>Número de Expediente (*)</label>
              <input type="text" class="form-control" id="inputNumeroExpediente" name="numero_expediente"
                [(ngModel)]="caso.numero_expediente" required [disabled]="isCaseClosed() || disableOptions"
                [ngClass]="{ 'is-invalid': (f.submitted && numero_expediente.invalid) || (numero_expediente.dirty && numero_expediente.invalid) }"
                #numero_expediente="ngModel">
            </div>

            <div class="col-md-3 mb-3">
              <label for="inputFechaSolicitud" class="form-label" i18n>Fecha de Solicitud (*)</label>
              <input type="date" class="form-control" id="inputFechaSolicitud" name="fecha_solicitud"
                [(ngModel)]="caso.fecha_solicitud" required [disabled]="isCaseClosed() || disableOptions"
                [ngClass]="{ 'is-invalid': (f.submitted && fecha_solicitud.invalid) || (fecha_solicitud.dirty && fecha_solicitud.invalid) }"
                #fecha_solicitud="ngModel">
            </div>

            <div class="col-md-4 mb-3">
              <label for="selectEstado" class="form-label" i18n>Estado (*)</label>
              <select class="form-select" id="selectEstado" name="estado" [(ngModel)]="caso.estado" required [disabled]="isCaseClosed() || disableOptions"
                [ngClass]="{ 'is-invalid': (f.submitted && estado.invalid) || (estado.dirty && estado.invalid) }"
                #estado="ngModel">
                <option value="ACTIVO" i18n>ACTIVO</option>
                <option value="CERRADO_LAUDO" i18n>CERRADO LAUDO</option>
                <option value="CERRADO_ACUERDO" i18n>CERRADO ACUERDO</option>
                <option value="CERRADO_OTROS" i18n>CERRADO OTROS</option>
                <option value="CERRADO_REENVIO" i18n>CERRADO REENVIO</option>
                <option value="SUSPENDIDO" i18n>SUSPENDIDO</option>
              </select>
            </div>

            <div class="col-md-3 mb-3">
              <label for="selectTipo" class="form-label" i18n>Tipo de Tribunal</label>
              <select class="form-select" id="selectTipo" name="tipo_tribunal" [(ngModel)]="caso.tipo_tribunal" [disabled]="isCaseClosed() || disableOptions"
                [ngClass]="{ 'is-invalid': (f.submitted && tipo_tribunal.invalid) || (tipo_tribunal.dirty && tipo_tribunal.invalid) }"
                #tipo_tribunal="ngModel">
                <option value="ARBITRO_UNICO" i18n>Árbitro único</option>
                <option value="TRIBUNAL_ARBITRAL" i18n>Tribunal arbitral</option>
                <option value="ARBITRO_EMERGENCIA" i18n>Árbitro de emergencia</option>
              </select>
            </div>            

            <div class="col-md-3 mb-3">
              <label for="inputFechaNotificacionLaudo" class="form-label" i18n>Fecha de notificación del laudo</label>
              <input type="date" class="form-control" id="inputFechaNotificacionLaudo" name="fecha_notificacion_laudo"
                [(ngModel)]="caso.fecha_notificacion_laudo" [disabled]="isCaseClosed() || disableOptions"
                [ngClass]="{ 'is-invalid': (f.submitted && fecha_notificacion_laudo.invalid) || (fecha_notificacion_laudo.dirty && fecha_notificacion_laudo.invalid) }"
                #fecha_notificacion_laudo="ngModel">
            </div>
            <div class="col-md-3 mb-3">
              <label for="inputFechaCierreFinanciero" class="form-label" i18n>Fecha de cierre financiero</label>
              <input type="date" class="form-control" id="inputFechaCierreFinanciero" name="fecha_cierre_financiero"
                [(ngModel)]="caso.fecha_cierre_financiero" [disabled]="isCaseClosed() || disableOptions"
                [ngClass]="{ 'is-invalid': (f.submitted && fecha_cierre_financiero.invalid) || (fecha_cierre_financiero.dirty && fecha_cierre_financiero.invalid) }"
                #fecha_cierre_financiero="ngModel">
            </div>

            <div class="col-md-3 mb-3"></div>

            <div class="col-md-3 mb-3">
              <label for="inputFechaConvenioArbitral" class="form-label" i18n>Fecha del convenio arbitral</label>
              <input type="date" class="form-control" id="inputFechaConvenioArbitral" name="fecha_convenio_arbitral"
                [(ngModel)]="caso.fecha_convenio_arbitral" [disabled]="isCaseClosed() || disableOptions"
                [ngClass]="{ 'is-invalid': (f.submitted && fecha_convenio_arbitral.invalid) || (fecha_convenio_arbitral.dirty && fecha_convenio_arbitral.invalid) }"
                #fecha_convenio_arbitral="ngModel">
            </div>

            <div class="col-md-3 mb-3" *ngIf="loggedInUser?.nivel_acceso === 'ADMIN'">
              <label for="inputFechaPrevistaLaudo" class="form-label" i18n>Fecha prevista de laudo</label>
              <input type="date" class="form-control" id="inputFechaPrevistaLaudo" name="fecha_prevista_laudo"
                [(ngModel)]="caso.fecha_prevista_laudo" [disabled]="isCaseClosed() || disableOptions"
                [ngClass]="{ 'is-invalid': (f.submitted && fecha_prevista_laudo.invalid) || (fecha_prevista_laudo.dirty && fecha_prevista_laudo.invalid) }"
                #fecha_prevista_laudo="ngModel">
            </div>            

            <div class="col-md-3 mb-3"></div>
            <div class="col-md-3 text-end mb-3">
              <button type="submit" class="btn btn-primary waves-effect waves-light" [disabled]="f.invalid || isCaseClosed() || disableOptions" [hidden]="isCaseClosed() || disableOptions">
                <span i18n>Guardar Cambios</span>
              </button>
            </div>

          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="confirm-delete-modal" *ngIf="showConfirmChangeModal">
  <div class="confirm-delete-modal-content">
    <div class="confirm-delete-modal-header">
      <h5 class="confirm-delete-modal-title">Confirmar Cambio de Estado</h5>
    </div>
    <div class="confirm-delete-modal-body">
      <p><span i18n>El estado del expediente está cambiando de </span> <strong>{{ previousEstado }}</strong><span i18n> a </span><strong>{{ caso.estado }}</strong>.</p>
      <p i18n>¿Estás seguro de que deseas guardar este cambio?</p>
    </div>
    <div class="confirm-delete-modal-footer">
      <button type="button" class="btn btn-secondary waves-effect waves-light"style="margin-right: 20px;" (click)="confirmStateChange()"><span i18n>Confirmar</span></button>
      <button type="button" class="btn btn-danger waves-effect waves-light" (click)="closeStateChangeModal()"><span i18n>Cancelar</span></button>
    </div>
  </div>
</div>
